function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M1714 113l4 67c389,-28 1168,126 1494,256 117,46 235,91 257,204 68,362 -705,296 -976,324 156,139 552,228 810,186 373,-60 900,-709 1330,107 131,249 199,511 71,770 -268,5 -256,-209 -518,-518 -79,615 568,1251 1073,1298 132,22 184,14 124,101 -16,344 -212,877 -452,966 -296,-359 -1,-621 -3,-959 -157,70 -327,312 -380,552 -68,304 -7,600 -50,861 -70,411 -494,934 -1011,740 -731,-275 324,-855 426,-937 234,-188 533,-829 487,-1306 -266,86 -598,440 -1119,578 -568,151 -827,-179 -1469,-71 -848,143 -1565,946 -1449,1971 96,844 749,1685 1740,1696 776,9 2414,-63 2921,-479 -370,-45 -1163,110 -1280,-232 137,-373 1417,-288 1891,-466 545,-203 978,-850 1014,-1329 -203,119 -306,310 -619,458 -161,77 -598,240 -779,260l8 -62c92,-175 569,-669 730,-825 641,-623 753,-1511 418,-2340 -100,-250 -429,-847 -576,-968l-56 -55 -4 35 33 49c124,334 474,1010 190,1330 -78,-141 -152,-448 -235,-620 -262,-544 -631,-1046 -1177,-1357 -1062,-606 -1932,-360 -2868,-285z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M398 1564c178,-50 341,-289 612,-353 16,132 22,295 86,400l45 -55c223,-320 117,-431 594,-515 441,-78 295,-545 -68,-622 -551,-115 -1121,591 -1269,1145z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M2323 1413c75,93 127,56 335,291 94,107 188,270 272,346 241,217 772,62 858,-193 118,-351 -266,-663 -584,-317 -332,362 -402,-202 -881,-127z"
});

var SvgRed = function SvgRed(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 7000 7000",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/red.69419539.svg";
export { ForwardRef as ReactComponent };